import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Scale } from 'lucide-react';

import { VaultComplianceContent } from '../components/VaultComplianceContent';

/**
 * VaultComplianceDashboardPage
 *
 * Page de conformité pour les gestionnaires, accessible depuis le dashboard.
 * Inclut un bouton retour pour revenir à la page précédente (où le VaultDrawer était ouvert).
 */
export const VaultComplianceDashboardPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-4xl px-6 py-8">
      {/* Header avec bouton retour */}
      <div className="mb-8">
        <button
          onClick={() => navigate(-1)}
          className="mb-4 flex items-center gap-2 text-sm font-medium text-neutral-500 transition-colors hover:text-neutral-700"
        >
          <ArrowLeft className="h-4 w-4" />
          {t('common.back', 'Retour')}
        </button>

        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-primary-100">
            <Scale className="h-6 w-6 text-primary-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-neutral-900">
              {t('vault.compliance.title', 'Conformité & Sécurité')}
            </h1>
            <p className="mt-1 text-neutral-500">
              {t('vault.compliance.subtitle', 'Documentation légale du coffre-fort numérique')}
            </p>
          </div>
        </div>
      </div>

      <VaultComplianceContent />
    </div>
  );
};
